import ccureApi from "@/services/api.ccure.service";
import { ServerType } from "@/constants/ServerType";
import { EventRecord } from "@/store/site-monitor/types";

type PostForceRestoreActionReference = (eventRecordId: number, restoralReason: string) => Promise<void>;

type PostForceRestoreAction = {
	[key in ServerType]?: PostForceRestoreActionReference;
};

/**
 * Object containing references for what each ServerTypeID should do after an event record has been force restored
 */
const postForceRestoreAction: PostForceRestoreAction = {
	[ServerType.CCure]: ccureApi.addLogEntryForForceRestore.bind(ccureApi)
};

/**
 * Performs additional methods for an event record that was force restored, if the server type is set up to do so
 * @param eventRecord The event record that was force restored
 * @param restoralReason The reason why it was force restored
 */
export const processEventRecordPostForceRestore = async (
	eventRecord: EventRecord,
	restoralReason: string
): Promise<void> => {
	const postForceRestoreActionToPerform: PostForceRestoreActionReference =
		postForceRestoreAction[eventRecord.serverTypeID];

	if (postForceRestoreActionToPerform) {
		await postForceRestoreActionToPerform(eventRecord.eventRecordID, restoralReason);
	}
};
